import { BaseModel } from "@/modules/api";
import { Item, GetItem, AddItem, DeleteItem } from "./eia.interface";

const Model = class extends BaseModel {
  private __category: string;

  constructor() {
    super();
    this.__category = "";
  }

  set category(category: string) {
    this.__category = category;
  }

  get category(): string {
    return this.__category;
  }

  public getItem: GetItem = async (id) => {
    const url = `/api/file/download/${id}`;
    const result = await this.get(url);
    return result;
  };

  public addItem: AddItem = async (file) => {
    const url = `/api/file/upload`;
    var formData = new FormData();
    formData.append("file", file);
    const result = await this.fileUpload(url, formData);
    return result.items[0];
  };

  static download = async (id: string) => {
    document.location = `${process.env.NEXT_PUBLIC_API_URL}/api/file/download/${id}`;
  };

  // public deleteItem: DeleteItem = async (projectIdx) => {
  //   const url = this.getPath(projectIdx);
  //   const result = await this.delete(url);
  //   return result.message === this._successMessage;
  // };
};

export default Model;
